/**
 * Parses mobile config `ff_show_all_iam_suppliers_in_delivery_options`.
 */
export function shouldShowAllIamSuppliersInDeliveryOptions(
  flagValue: unknown,
): boolean {
  return flagValue === true || flagValue === "true";
}
